import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, tap } from 'rxjs'
import { ServicePlanReconciliationItemDto } from 'src/app/models/service-plan/service-plan-reconciliation-item-dto'
import { ApplicationInsightsService } from '../application-insights/application-insights.service'
import { ConfigService } from '../config/config.service'

// Story e10-1 — calls the new, additive, read-only GET api/ServicePlan/reconciliation endpoint. A
// sibling service, not a retrofit of ServicePlanSubmissionService — this feature's established
// one-service-per-endpoint-group convention (e9-1/e9-2 precedent).
@Injectable({
  providedIn: 'root',
})
export class ServicePlanReconciliationService {
  private readonly baseUrl =
    this.config.getSettings('webApi').baseUri + 'serviceplan/'

  constructor(
    private http: HttpClient,
    private appInsights: ApplicationInsightsService,
    private config: ConfigService,
  ) {}

  GetReconciliation(
    windowDays: number,
    incompleteOnly: boolean,
  ): Observable<ServicePlanReconciliationItemDto[]> {
    return this.http
      .get<ServicePlanReconciliationItemDto[]>(
        this.baseUrl + 'reconciliation',
        {
          params: { windowDays, incompleteOnly },
        },
      )
      .pipe(
        map((response) => response as ServicePlanReconciliationItemDto[]),
        tap((_) =>
          this.appInsights.logEvent('Retrieved Service Plan reconciliation'),
        ),
        catchError(async (err) => {
          throw err
        }),
      )
  }
}
